module.exports = __webpack_public_path__ + "img/img6.cd86c2dd.png";